import React, { ReactElement, useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { SlidePanel, FormInput, FormTextarea } from 'ui/patterns';
import { Button, Stack, Toggle } from 'ui/components';

import { useSaveContact, useGetContactInfo } from 'hooks';

import { showErrorToast } from 'utils/showToast';

import { AddEditContactPageProps } from './addEditContactTypes';
import { ContactList } from 'types/contacts';
import { ErrorModal } from 'types/modalTypes';

const formDefaults = {
  Name: '',
  PhoneNumber: '',
  Notes: '',
  IsUsedByCallCenter: false,
  IsForwardedToProtoCall: false,
  IsOkToGiveOutNumber: false,
};

export default function AddEditContact({
  showPanel,
  togglePanel,
  contactId,
  accountId,
  mode,
}: AddEditContactPageProps): ReactElement {
  const { data: contactInfo } = useGetContactInfo({
    account: accountId,
    id: contactId,
  });
  const { register, handleSubmit, reset } = useForm();
  const { mutate: saveContact, isLoading } = useSaveContact();
  useEffect(() => {
    if (contactInfo !== undefined)
      reset({
        ...contactInfo?.Data,
      });
  }, [contactInfo, reset]);

  function resetForm() {
    reset(formDefaults);
  }

  function onSubmit(data: ContactList) {
    saveContact(
      {
        ...data,
        AccountId: accountId,
        Id: contactId,
      },
      {
        onSuccess: () => {
          togglePanel();
          resetForm();
        },
        onError: (error: ErrorModal) => {
          showErrorToast({ message: error.Errors[0].Message });
        },
      },
    );
  }
  const addContactActions = () => (
    <>
      <Button
        variant="secondary"
        onClick={() => {
          togglePanel();
          resetForm();
        }}
      >
        Cancel
      </Button>
      <Button
        onClick={handleSubmit(onSubmit)}
        type="submit"
        variant="primary"
        disabled={isLoading}
      >
        Save
      </Button>
    </>
  );
  return (
    <>
      <SlidePanel
        title={`${mode === 'Edit' ? 'Edit Contact' : 'Add New Contact'}`}
        actions={addContactActions()}
        onClose={() => {
          togglePanel();
          resetForm();
        }}
        open={showPanel}
      >
        <Stack direction="y" gap={4}>
          <FormInput
            register={register}
            name="Name"
            label="Name"
            type="text"
            required
          />
          <FormInput
            register={register}
            name="PhoneNumber"
            label="Phone Number"
            type="tel"
          />
          <FormTextarea name="Notes" register={register} label="Notes" />

          <Toggle
            name={'IsUsedByCallCenter'}
            register={register}
            label="Used by Call Center"
          />
          <Toggle
            name={'IsForwardedToProtoCall'}
            register={register}
            label="Forwarded to Protocall"
          />
          <Toggle
            name={'IsOkToGiveOutNumber'}
            register={register}
            label="Ok to give out number"
          />
        </Stack>
      </SlidePanel>
    </>
  );
}
